import { HEIGHT_FIXED_BANNER_TABLET, MAX_SCREEN_TABLET, MAX_SCREEN_WIDTH, MIN_SCREEN_TABLET } from '@/app/constants/layoutConfig';
import React from 'react';

interface ResponsiveImageProps {
    image: string;
    imageMobile?: string;
    alt?: string;
    link?: string;
    minHeight?: string;
    height?: string;
    isFixedHeight?: boolean;
    priority?: boolean;
    onError?: () => void;
    onLoad?: (e: any) => void;
    onClick?: () => void;
    style?: React.CSSProperties;
}

const ResponsiveImage: React.FC<ResponsiveImageProps> = ({
    image,
    imageMobile,
    alt = 'Banner Image',
    link = '',
    minHeight = '230px',
    priority = false,
    onError,
    onLoad,
    onClick,
    style = {},
}) => {
    const handleClick = () => {
        if (onClick) {
            onClick();
        } else if (link) {
            window.location.href = link;
        }
    };

    const isNonMobile = typeof window !== 'undefined' && window.innerWidth > MIN_SCREEN_TABLET;
    
    // Use maxHeight from style prop if provided, otherwise use default height
    const imageHeight = style.maxHeight 
        ? (typeof style.maxHeight === 'number' ? `${style.maxHeight}px` : style.maxHeight)
        : `${HEIGHT_FIXED_BANNER_TABLET}px`;

    // Extract maxHeight from style to avoid overriding height
    const { maxHeight, ...restStyle } = style;

    return (
        <picture style={{ width: '100%', height: 'auto' }}>
            {imageMobile && (
                <source
                    media={`(max-width: ${MIN_SCREEN_TABLET}px)`}
                    srcSet={imageMobile}
                />
            )}
            <source
                media={`(min-width: ${MIN_SCREEN_TABLET}px)`}
                srcSet={image}
            />
            <img
                src={image} // Fallback image
                alt={alt}
                draggable={false}
                onContextMenu={(e) => { e.preventDefault(); e.stopPropagation(); }}
                loading={priority ? 'eager' : 'lazy'}
                {...(priority ? { fetchPriority: 'high' } : {})}
                style={{
                    minHeight: minHeight,
                    height: imageHeight,
                    maxHeight: maxHeight || imageHeight,
                    width: '100%',
                    borderRadius: '0px',
                    objectFit: 'cover',
                    display: 'block',
                    cursor: 'pointer',
                    ...restStyle,
                }}
                onError={onError}
                onLoad={onLoad}
                onClick={onClick ? handleClick : () => null}
            />
        </picture>
    );
};

export default ResponsiveImage;
